<script>

import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import config from "../../config";
import pagination from "laravel-vue-pagination";
import { productService } from "../../services";
import DropzonePopup from "../../components/widgets/dropzone-popup";
import draggable from "vuedraggable";
import { debounce,success_message,error_message ,get_currency } from "../../Helper/helper";
import { required, requiredIf } from "vuelidate/lib/validators";

export default {
  components: { Layout, PageHeader, pagination, productService, DropzonePopup, draggable },
    data() {
        const { status,orderBy,sortBy} = this.$route.query;
        return {
            currency: get_currency(),
            title: this.trans.get('__JSON__.Sub Products'),
            url: null,
            debounce: false,
            barcodeModal: false,
            items: [],
            checked: true,
            sortBy: sortBy || 'reorder',
            sortDesc: orderBy && orderBy != '' ? true : orderBy,
            loading: true,
            paginations: {},
            product: {},
            subProduct: {},
            limit: 1,
            search: "",
            status: status == undefined ? '1' :status,
            config: config,
            product_id: this.$route.params.product_id,
            productCount: "",
            searchData:debounce(()=>{
                if(!this.init){
                    const {status,orderBy,sortBy} = this.$data;
                    this.$router.replace({name: 'sub-product-list', query: {status,orderBy,sortBy}})
                }
                this.getSubProduct();
                this.init = false;
            },500),
            
            fields: [
                { key: "image", label: "#", sortable: false },
                // { key: "barcode_image", label: "Barcode", sortable: false },
                { key: "sub_product_name", label: "Sub Product", sortable: false },
                { key: "barcode_number", label: "Barcode", sortable: false },
                { key: "product_number", label: "Product Number", sortable: true },
                { key: "quantity", label: "Quantity", sortable: true },
                { key: "sale_price", label: "Private Selling Price", sortable: true },
                { key: "business_sale_price", label: "Business Selling Price", sortable: true },
                { key: "reorder", label: "Order", sortable: true },
                { key: "status", label: "Status", sortable: false ,thClass:"dis-event"},
                { key: "action", label: "Action", sortable: false, thClass:"dis-event" },
            ],
            barcode_image: "",
            image_id: "",
            subProductQuantityModal : false,
            subProductData : {
                currentQuantity : 0,
                productNumber : '',
                barcodeNumber : '',
                sellingQuantity : 0,
                size : '',
                attribute : '',
                material : '',
                quantity : '',
                totalQuantity : '',
                id : ''
            },
            btnDisabled : true
        };
    },
    validations: {
        subProductData: {
            quantity: {
                required,
            }
        }
    },
    mounted() {
        this.getSubProduct();
        this.getProductById();
    },
    methods: {
        sortingChanged(ctx) {
            this.sortBy = ctx.sortBy;
            this.sortDesc = ctx.sortDesc;
            this.getSubProduct();
        },
        getSubProduct(page) {
            this.loading = true;
            productService
            .getSubProduct({ 
                search: this.search,
                status: this.status,
                sortBy: this.sortBy,
                orderBy: this.sortDesc ? "desc" : "asc",
                page: page && page > 0 ? page : 1,
                product_id : this.product_id
            })
            .then((response) => {
                this.loading = false;
                this.paginations = response.data.result;
                this.items = response.data.result.data;
                this.productCount = response.data.result.data.length;
            });
        },
        getProductById(){
            productService
            .getProductById({id: this.$route.params.product_id, type:'get'})
            .then((response) => {
                this.product = response.data.result;
            });
        },
        deleteSubProduct(id){
            if(confirm("Do you really want to delete?")){
                productService.deleteSubProduct({id: id})
                .then(response => {
                    if (response.data.code === 200) {
                        this.getSubProduct();
                        success_message(response.data.message);
                    } else {
                        error_message(response.data.message);
                    }
                });
            }
        },
        viewBarcode(id, image){
            this.image_id = id;
            this.barcode_image = image;
            this.barcodeModal = true;
        },
        editSubProductQuantity(id){
            productService
            .getSubProductById({ id: id, type: "get" }).then((response) => {
                this.subProductData.currentQuantity = response.data.result.data.quantity;
                this.subProductData.productNumber = response.data.result.data.product_number;
                this.subProductData.barcodeNumber = response.data.result.data.barcode_number;
                this.subProductData.sellingQuantity = response.data.result.data.selling_qty;
                this.subProductData.size = response.data.result.attributes.size_data.att_name;
                this.subProductData.attribute_material = response.data.result.attributes.material_data.att_name;
                this.subProductData.id = id;
                this.subProductQuantityModal = true;
            });
        },
        quantityHandler(event) {
            if(this.subProductData.quantity != 0){
                this.subProductData.totalQuantity = Number(this.subProductData.currentQuantity) + Number(this.subProductData.quantity);
                this.btnDisabled = false;
            }else{
                this.subProductData.totalQuantity = Number(this.subProductData.currentQuantity) - Number(this.subProductData.quantity);
                this.btnDisabled = true;
            }
        },
        updateQuantity(){
            this.$v.subProductData.$touch();
            if (!this.$v.subProductData.$invalid) {
                this.btnDisabled = true;
                productService.updateSubProductQuantity(this.subProductData).then((response) => {
                    if (response.data.code == 200) {
                        success_message(response.data.message);
                        location.reload(true);                  
                    } else {
                        error_message(response.data.message);
                    }
                    this.btnDisabled = false;
                    this.subProductQuantityModal = false;
                });
            }
        },
        contactNumber(evt) {
            let val1 = evt.target.value;
            if ((evt.keyCode == 118 && val1.length <= 13) || evt.keyCode == 99) {
                return evt.target.value;
            }

            if (!(evt.keyCode == 43 || (evt.keyCode >= 48 && evt.keyCode <= 57))) {
                evt.preventDefault();
            }

            if (
                evt.keyCode == 43 &&
                evt.target.selectionStart !== undefined &&
                evt.target.selectionStart !== 0
            ) {
                evt.preventDefault();
            }
            return evt.target.value;
        },
        onClose(){
            this.subProductQuantityModal = false;
            this.subProductData = {
                quantity: '',
            }
            this.$v.subProductData.$reset();
        },
        retrieveFilterValues() {
            const savedFilters = JSON.parse(localStorage.getItem('productFilters'));
            this.$router.push({ 
                name: 'product-list',
                query: {
                    status: savedFilters.status,
                    menu_id: savedFilters.menu_id,
                    sortBy: savedFilters.sortBy,
                    sortDesc: savedFilters.sortDesc,
                    search: savedFilters.search
                }
            })
        },
    },
};

</script>
<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="page-title-box d-flex align-items-center justify-content-between icon-main-page" >
                    <div class="page-title-left">
                        <div class="avatar-xs mr-3 avatar-main-icon">
                            <span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18">
                                <i class="bx bx-user-circle"></i>
                            </span>
                        </div>
                        <div class="report-tag">
                            <h4 class="mb-0 font-size-18">{{ product.item_name }}</h4>
                            <p><router-link :to="{ name: 'product-list'}">{{ trans.get('__JSON__.Products') }}</router-link> > {{ product.item_name }} > {{ trans.trans('__JSON__.Sub Products') }}({{productCount}})</p>
                        </div>
                    </div>
                    <div class="page-title-right d-flex">
                        <router-link :to="{name: 'sub-product-add',params: { product_id:this.$route.params.product_id}}" class="btn btn-success btn-rounded mr-2 add-btn">
                            <i class="mdi mdi-plus mr-1"></i>
                            {{ trans.get('__JSON__.Add Sub Product') }}
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="row list-table-main">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-2 offset-sm-8">
                                <div class="form-group">
                                    <div class="date-range-list">
                                        <label>{{ trans.get('__JSON__.Status') }} :</label>
                                        <select class="custom-select" v-model="status" @change="searchData()">
                                        <option value="">{{ trans.get('__JSON__.All') }}</option>
                                        <option value="1" selected>{{ trans.get('__JSON__.Active') }}</option>
                                        <option value="0">{{ trans.get('__JSON__.Inactive') }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-2">
                                <div class="date-range-list">
                                    <label>{{ trans.get('__JSON__.Search') }} :</label>
                                    <div class="text-sm-right">
                                        <div class="search-box mr-2 d-inline-block">
                                            <div class="position-relative">
                                                <input
                                                type="text"
                                                class="form-control"
                                                id="search"
                                                @input="searchData()"
                                                v-model="search"
                                                :placeholder="trans.get('__JSON__.Search Placeholder')"
                                                />
                                                <i class="bx bx-search-alt search-icon"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12 offset-sm-12">
                                <router-link :to="{name: 'sub-product-order',params: { product_id:this.$route.params.product_id}}" style="float: right; padding-right: 10px;">
                                {{ trans.get('__JSON__.Reorder') }}
                            </router-link>
                            </div>
                            <div class="col-12 table-main-list product-table table-responsive">
                                <b-table
                                :items="items"
                                :fields="fields"
                                :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc"
                                :no-local-sorting="true"
                                @sort-changed="sortingChanged"
                                :busy="loading"
                                show-empty
                                >
                                <template #table-busy>
                                    <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>{{trans.get('__JSON__.Loading...')}}</strong>
                                    </div>
                                </template>
                                
                                <template v-slot:cell(image)="data">
                                    <div v-if="data.item.product_image[0]">
                                        <img alt title="image"
                                            class="vendor-img avatar-xs"
                                            :src="config.sub_product+data.item.id+'/original/'+data.item.product_image[0].image"
                                        />   
                                    </div>
                                    <div v-else>
                                        <img class="vendor-img avatar-xs" :src="config.basepath+'no-img.png'" alt />
                                    </div>
                                </template>

                                <!-- <template v-slot:cell(barcode_image)="data">
                                    <div v-if="data.item.barcode_image">
                                        <img alt title="barcode_image"
                                            class="vendor-img avatar-xs"
                                            :src="config.sub_product+'BarCode/'+product.id+'/original/'+data.item.barcode_image"
                                            @error="$event.target.src=config.basepath+'no-img.png'"
                                            @click="viewBarcode(product.id,data.item.barcode_image) "
                                        />   
                                    </div>
                                    <div v-else>
                                       <span>-</span>
                                    </div>
                                </template> -->
                                
                                <template v-slot:cell(sub_product_name)="data">
                                    <h5 class="font-size-14">{{ data.item.sub_product_name }} ({{ data.item.material }})</h5>
                                </template>

                                <template v-slot:cell(barcode_number)="data">
                                    <h5 class="font-size-14">{{ data.item.barcode_number }}</h5>
                                </template>
                                
                                <template v-slot:cell(product_number)="data">
                                    <h5 class="font-size-14">{{ data.item.product_number }}</h5>
                                </template>

                                <template v-slot:cell(quantity)="data">
                                    <span>{{ data.item.quantity }}</span>
                                    <button
                                        type="submit"
                                        @click="editSubProductQuantity(base64(data.item.id),data.item.quantity) "
                                        class="btn btn-success btn-sm btn-rounded ml-1"
                                    >{{ trans.get('__JSON__.Edit') }}</button>
                                </template>

                                <!-- <template v-slot:cell(per_unit_price)="data">
                                    <span>{{ data.item.per_unit_price }}</span>
                                </template> -->

                                <template v-slot:cell(sale_price)="data">
                                    <span>{{ data.item.price }} <span v-html="currency"></span> / </span>
                                    <span>{{ data.item.sale_price }} <span v-html="currency"></span> </span>
                                </template>

                                <template v-slot:cell(business_sale_price)="data">
                                    <span>{{ data.item.business_customer_price }} <span v-html="currency"></span> / </span>
                                    <span>{{ data.item.business_sale_price }} <span v-html="currency"></span> </span>
                                </template>

                                <template v-slot:cell(reorder)="data">
                                    <span>{{ data.item.reorder }}</span>
                                </template>

                                <template v-slot:cell(status)="data">
                                    <div
                                    v-if="data.item.status === '0'"
                                    class="badge badge-pill badge-soft-danger font-size-12"
                                    >{{ trans.get('__JSON__.Inactive') }}</div>
                                    <div
                                    v-else
                                    class="badge badge-pill badge-soft-success font-size-12"
                                    >{{ trans.get('__JSON__.Active') }}</div>
                                </template>

                                <template v-slot:cell(action)="data">
                                    <router-link
                                    :to="{name: 'sub-product-edit',params: { id:base64(data.item.id)}}"
                                    class="btn btn-success btn-sm btn-rounded"
                                    >Edit</router-link>

                                    <button
                                        type="submit"
                                        @click="deleteSubProduct(base64(data.item.id))"
                                        class="btn btn-danger btn-sm btn-rounded ml-1"
                                    >{{ trans.get('__JSON__.Delete') }}</button>
                                </template>

                                <template #empty>
                                    <p class="text-center">{{ trans.get('__JSON__.No Sub Product') }}</p>
                                </template>
                                </b-table>
                            </div>
                            <div class="row col-sm-5 offset-sm-7">
                                <div class="col">
                                    <div class="dataTables_paginate paging_simple_numbers float-right">
                                        <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                            <pagination
                                                :data="paginations"
                                                :limit="limit"
                                                @pagination-change-page="getSubProduct"
                                            ></pagination>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--Barcode Modal Start -->
        <b-modal v-model="barcodeModal" :hide-footer="true">
            <div class="row">
                <div class="col-sm-12 text-center">
                    <div style="height:100px">
                        <img alt title="barcode_image"
                            :src="config.sub_product+'BarCode/'+image_id+'/original/'+barcode_image"
                            @error="$event.target.src=config.basepath+'no-img.png'"
                        />
                    </div>
                </div>
            </div>
        </b-modal>
        <!--Barcode Modal End -->


        <!--SubProduct Quantity Modal Start -->
        <b-modal v-model="subProductQuantityModal" size="xl" hide-header-close>
            <template #modal-title>
                <div class="edit-qunt-header">
                    <h5>{{ product.item_name }} - {{subProductData.sellingQuantity}} x {{ subProductData.size }} ({{ subProductData.attribute_material }})</h5>
                    <div class="d-flex gap-2">
                        <p>ArtikelNr : <span class="fw-normal">{{ subProductData.productNumber }}</span></p>  |  <p>EAN : <span class="fw-normal">{{ subProductData.barcodeNumber }}</span></p>
                    </div>
                    <b-button variant="light" class="cust-close"><img :src="config.basepath+'close-ic.svg'" alt=""  @click="onClose"></b-button>
                </div>
            </template>
            <b-form @submit.prevent="updateQuantity">
                <div class="row edit-qunt-body">
                    <div class="col">
                        <label for="currentQuantity">Current quantity</label>
                        <input
                            type="text"
                            class="form-control"
                            id="currentQuantity"
                            v-model="subProductData.currentQuantity"
                            disabled
                            :placeholder="trans.get('__JSON__.Quantity')"
                        />
                    </div>
                    <div class="col-1 text-center d-flex align-items-end justify-content-center">
                        <span class="symbolsign"><img :src="config.basepath+'plus-ic.svg'" alt=""></span>
                    </div>
                    <div class="col validation-main">
                        <label for="quantity">Add additional quantity</label>
                        <input
                            minlength="1"
                            maxlength="5"
                            type="text"
                            class="form-control"
                            id="quantity"
                            v-model="$v.subProductData.quantity.$model"
                            v-on:keyup="quantityHandler($event)"
                            :placeholder="trans.get('__JSON__.e.g. 100')"
                            @keypress="contactNumber($event)"
                            :class="{ 'is-invalid': $v.subProductData.quantity.$error }"
                        />
                        <div v-if="$v.subProductData.quantity.$error" class="invalid-feedback" >
                            <span v-if="!$v.subProductData.quantity.required">{{ trans.get("__JSON__.Please enter quantity") }}</span>
                        </div>
                    </div>
                    <div class="col-1 text-center d-flex align-items-end justify-content-center">
                        <span class="symbolsign"><img :src="config.basepath+'equal-ic.svg'" alt=""></span>
                    </div>
                    <div class="col">
                        <label for="totalQuantity">Total new quantity</label>
                        <input
                            type="text"
                            class="form-control"
                            id="totalQuantity"
                            v-model="subProductData.totalQuantity"
                            disabled
                            :placeholder="trans.get('__JSON__.Quantity')"
                        />
                    </div>
                </div>
            </b-form>
            <template slot="modal-footer">
                <div class="w-100">
                    <b-button variant="primary" :disabled="btnDisabled" class="float-right btn--primary" @click="updateQuantity" >{{ trans.get("__JSON__.Update") }}</b-button>
                </div>
            </template>
        </b-modal>
        <!--SubProduct Quantity Modal End -->
    </div>
</template>